import { COLORS } from '@/styles/color';
import { mediaBreakpointUp, square } from '@/styles/layout/utils';
import { customTextSize, remCalc } from '@/styles/typography/utils';
import { FC, ReactNode } from 'react';
import styled from 'styled-components';

interface IconCardProps {
  glyph: ReactNode;
  text: ReactNode;
}

const IconCard: FC<IconCardProps> = ({ glyph, text }) => {
  return (
    <Card>
      <GlyphWrapper>{glyph}</GlyphWrapper>
      <Text>{text}</Text>
    </Card>
  );
};

export default IconCard;

// Styled Components

const Card = styled.div`
  background: ${COLORS.WHITE};
  box-shadow: 0 0 ${remCalc(20)} rgba(0, 27, 56, 0.1);
  border-radius: ${remCalc(10)};
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  padding: ${remCalc(30, 47)};
  text-align: center;

  ${mediaBreakpointUp('desktop')} {
    padding: ${remCalc(30, 16)};
  }

  ${mediaBreakpointUp('desktopWide')} {
    padding: ${remCalc(30)};
  }
`;

const GlyphWrapper = styled.div`
  ${square(80)}
  margin-bottom: ${remCalc(10)};

  ${mediaBreakpointUp('desktopWide')} {
    margin-bottom: ${remCalc(20)};
  }
`;

const Text = styled.p`
  ${customTextSize(16, 20)};

  ${mediaBreakpointUp('desktopWide')} {
    ${customTextSize(20, 24)};
  }
`;
